import { useTranslation } from '@klv/hooks/useTranslation';

import Button from '@klv/atoms/button';
import Icon from '@klv/atoms/icon';
import TranslatedDate from '@klv/atoms/translated-date';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/newsFeed.module.scss';

import type { IStaticNewsFeed, IPostData } from './types';

const NewsFeed = ({ backgroundColor, className, posts, categoryLink }: IStaticNewsFeed) => {
  const { t } = useTranslation();

  return (
    <div className={generateClassName(['newsFeed', className, styles.newsFeed, styles[backgroundColor]])}>
      <div className={generateClassName(['h6', styles.newsFeedTitle])}>
        {`${t('organisms_newsFeed_productNews')}`}
      </div>
      {
        posts && posts.map(({
          link, date, title, featuredImage, templatesEditorial: { postTitle: { shortTitle } },
        }: IPostData) => {
          const truncateTitle = (title.length >= 40) ? `${title.slice(0, 40)}...` : title;
          return (
            <a className={styles.postLink} href={link} key={link}>
              {featuredImage ? (
                <div className={styles.imageContainer}>
                  <img
                    className={styles.image}
                    height={75}
                    src={featuredImage.node.sourceUrl}
                    srcSet={featuredImage.node.srcSet}
                    width={112}
                  />
                  <div className={styles.textContent}>
                    <div className={generateClassName(['p3', 'semiBold', styles.imageText])}>
                      {t('organisms_newsFeed_read')}
                    </div>
                  </div>
                </div>
              ) : (
                <div className={generateClassName([styles.imagePlaceholderContainer, styles.image])}>
                  <Icon
                    aria-label={t('organisms_newsFeed_klaviyoLogo')}
                    className={styles.klaviyoLogo}
                    iconName="BugMarkFilled"
                    role="img"
                  />
                  <div>
                    <div className={generateClassName(['p3', 'semiBold'])}>
                      {t('organisms_newsFeed_read')}
                    </div>
                  </div>
                </div>
              )}
              <div className={styles.postText}>
                <div className={generateClassName(['p3', 'semiBold', styles.postTitle])}>
                  { shortTitle || truncateTitle }
                </div>
                <div className={generateClassName(['disclaimer', styles.postDate])}>
                  <TranslatedDate date={date} />
                </div>
              </div>
            </a>
          );
        })
      }
      <Button
        buttonColor={backgroundColor === 'light' ? 'dark' : 'light'}
        className={styles.button}
        text={t('organisms_newsFeed_viewAll')}
        to={categoryLink}
        variant="tertiary"
      />
    </div>
  );
};

export default NewsFeed;
